import React, { Fragment } from "react";
import { connect, useSelector } from "react-redux";
import { bool, func, shape } from "prop-types";

import { actions as cedipActions } from "reducers/cedip";

import ViewTitle from "pages/_components/header/components/ViewTitle";
import Notification from "pages/_components/Notification";
import CustomProductHead from "pages/_components/CustomProductHead";
import CustomTabs from "pages/_components/CustomTabs/CustomTabs";
import CustomData from "pages/_components/CustomData/CustomData";
import MainContainer from "pages/_components/MainContainer";
import GridCedip from "../GridCedip/GridCedip";

const ManagementCedipPage = ({ dispatch, fetching, filters, ...props }) => {
    const { cedipList = [] } = useSelector((state) => state.cedip);
    const isLoading = fetching && !cedipList.length;
    const { isDesktop } = props;

    const tabsData = [
        {
            text: "cedip.list.tab1.title",
            textType: "I18N",
            downloadData: {
                active: true,
                filters: {},
                cedipList,
            },
        },
        {
            text: "cedip.list.tab2.title",
            textType: "I18N",
            downloadData: {
                active: false,
                filters,
                cedipList: [],
            },
        },
        {
            text: "cedip.list.tab3.title",
            textType: "I18N",
            downloadData: {
                active: false,
                filters,
                cedipList: [],
            },
        },
    ];

    const fetchMoreTransactions = (cedipPagination, _filters) => {
        const filtersCedip = {
            ..._filters,
            pageNumber: cedipPagination.pageNumber + 1,
        };
        dispatch(cedipActions.filterCedipList(filtersCedip));
    };

    const renderHeader = () => (
        <CustomProductHead
            titleId="cedip.list.title"
            backLinkTo="/desktop"
            addLinkToLabel="deposits.new"
            addLinkTo="/deposits/requestForm"
            className="deposits">
            <div className="toolbar-item view-title">
                <ViewTitle id="cedip.list.title" />
            </div>
        </CustomProductHead>
    );

    const renderMessageInfo = () => (
        <>
            <div className="container--alert" role="alert">
                <div className="alert alert-info">
                    <CustomData
                        icon="information_fill.svg"
                        titleText="cedip.list.info"
                        titleTextType="I18N"
                        keepSpaceIfNoValue={false}
                    />
                </div>
            </div>
        </>
    );

    return (
        <Fragment>
            <Notification scopeToShow="deposits" />
            {!isLoading && renderHeader()}
            <MainContainer>
                {renderMessageInfo()}
                <div className="container">
                    <CustomTabs tabsData={tabsData} defaultTab={0}>
                        <GridCedip
                            isDesktop={isDesktop}
                            fetchMoreTransactions={fetchMoreTransactions}
                            positionTab={0}
                        />
                        <GridCedip
                            isDesktop={isDesktop}
                            fetchMoreTransactions={fetchMoreTransactions}
                            positionTab={1}
                        />
                        <GridCedip
                            isDesktop={isDesktop}
                            fetchMoreTransactions={fetchMoreTransactions}
                            positionTab={2}
                        />
                    </CustomTabs>
                </div>
            </MainContainer>
        </Fragment>
    );
};

ManagementCedipPage.propTypes = {
    fetching: bool.isRequired,
    dispatch: func.isRequired,
    filters: shape({}).isRequired,
    isDesktop: bool.isRequired,
};

const mapStateToProps = () => ({});

export default connect(mapStateToProps)(ManagementCedipPage);
